// extracted by mini-css-extract-plugin
export default {"container":"_3-epZ","square":"_35E9y","wide":"_2xcWk"};